const NacionalidadOptions = [
  {
    label: "Nacionalidad",
    value: '',
  },
  {
    label: "Nacional",
    value: "Nacional"
  },
  {
    label: "Extranjero",
    value: "Extranjero"
  }
];

export default NacionalidadOptions;